import { defineManifest } from "@crialume/sdk";
import { AddressBookIcon } from "@crialume/ui/icons";

/**
 * Único arquivo do módulo que entra no bundle inicial — mantenha-o leve:
 * nada de imports de páginas aqui, só o `loader` dinâmico.
 */
export default defineManifest({
  id: "leads",
  version: "0.1.0",
  meta: {
    name: "Leads",
    description: "Contatos de quem passou pelo checkout",
    icon: AddressBookIcon,
    category: "business",
    order: 4,
  },
  requirements: {
    permissions: ["leads.view"],
  },
  nav: [{ label: "Leads", path: "", icon: AddressBookIcon }],
  loader: () => import("./module"),
});
